import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import { resolveUrl } from "v4/features/front/navigation/utils/route.utils";
import ManageTasksActions
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectQuotesTab/components/ProspectQuoteTabShow/components/QuoteTasksButton/components/ManageTasks/components/ManageTasksActions/ManageTasksActions";

export default function ManageTasksRow({prospectId, id, name, beginAt, isMailing, isSynchroOutlook, isClosed, isReminder, isUnSelectable}) {
    const [_beginAt, setBeginAt] = useState(beginAt);
    const { getRouteByNativeIdentifier } = useNavigation();

    return (
        <div className="manage-task__row">
            <div className="manage-task__row__title">
                <Link
                    to={`/${resolveUrl(getRouteByNativeIdentifier(getNativeIdentifier(isMailing, isSynchroOutlook, isClosed))?.url, {prospect: prospectId})}/${id}`}>
                    {name}
                </Link>
                <p>{_beginAt}</p>
            </div>
            <ManageTasksActions
                taskId={id}
                changeDate={setBeginAt}
                canRenew={isReminder}
                defaultCanClose={!isClosed}/>
        </div>
    )
}


function getNativeIdentifier (isMailing, isSynchroOutlook, isClosed) {
    if (isMailing) return 'detail_mail_history';

    if (isSynchroOutlook) return 'detail_received_mails';

    return isClosed ? 'detail_closed_tasks' : 'detail_open_tasks';
}
